import { globalVariables } from "helper/globalVariables";
import { BottomButtons } from "shared/Components/bottomButtons";
import { client } from "helper/apolloConfig";
import {
  MakePendingDogPayments,
  REGISTER_DOG_FOR_FREE,
  addPayment,
} from "redux/features/dogSlice/dogGql";
import { Header } from "shared/Components/header";
import "./modules.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { DOG_REGISTRATION_FEE, useURLQuery } from "helper/utility";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { PopUpMessages } from "shared/Components/popUpMessages";
import { StepsHeader } from "shared/Components/stepsHeader";
import { setDogsAction } from "redux/features/dogSlice/dogReducerSlice";
import { setRefresh } from "redux/globalSlice";
import { useLogout } from "helper/logout";
import { OutlineButton } from "shared/Components/outlineButton";
import { logout } from "helper/icons";

export const MakePayment = ({
  isCustom = false,
  onPressBack = () => {},
  forUnPaid = false,
}) => {
  const dispatch = useDispatch();
  const [skipLoading, setSkipLoading] = useState(false);
  const modalRef = useRef();
  const [message, setMessageData] = useState({
    title: "",
    desc: "",
    type: "pending",
  });
  const { onLogout } = useLogout();

  //For Payment Error
  const query = useURLQuery();
  const paymentError = query?.get("payment_error");
  const forUnPaidQuery = query?.get("forUnPaid") === "true";

  useEffect(() => {
    if (paymentError) {
      setMessageData({
        ...message,
        desc: globalVariables.paymentFailed,
        title: globalVariables.error,
      });
      modalRef.current.openModal();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentError]);

  const { dogsData } = useSelector((state) => state.dogs);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Determine if we're in the new flow (dogs already created)
  const isNewFlow = forUnPaid || forUnPaidQuery;

  const onGoBack = () => {
    if (isCustom) {
      onPressBack();
    } else {
      navigate(-1);
    }
  };

  const TotalPayment = dogsData.length * DOG_REGISTRATION_FEE;

  // Pay Later: Dogs are already created, trigger refresh and navigate to dashboard
  const onPayLater = () => {
    dispatch(setDogsAction([]));
    dispatch(setRefresh()); // This triggers refetch of member profile and updates initialRoute
    // Navigation will happen automatically via the routing logic after refresh
  };

  // OLD FLOW - COMMENTED OUT - NOT USED ANYMORE
  // const onPay = async (skipPayment = false) => {
  //   try {
  //     const dogsList = dogsData.map((dog) => {
  //       return {
  //         call_name: dog?.callName,
  //         registration_name: dog?.registrationName,
  //         breed: dog?.breed,
  //         breed_mix: dog?.breedMix,
  //         gender: dog?.gender,
  //         date_of_birth: moment(dog?.dob).format(),
  //         rescue: dog?.isRescueYes,
  //         dogImage: dog?.image,
  //       };
  //     });
  //     const data = {
  //       payment_method: "Paypal",
  //       amount: TotalPayment,
  //       currency: "USD",
  //       dog_details: dogsList,
  //     };

  //     if (skipPayment) {
  //       setSkipLoading(true);
  //       const result = await client.mutate({
  //         mutation: REGISTER_DOG_FOR_FREE,
  //         variables: {
  //           data: dogsList,
  //         },
  //       });
  //       if (result.data) {
  //         dispatch(setDogsAction([]));
  //         if (isCustom) {
  //           navigate("/");
  //         } else {
  //           dispatch(setRefresh());
  //         }
  //       }
  //       setSkipLoading(false);
  //     } else {
  //       setLoading(true);
  //       const result = await client.mutate({
  //         mutation: addPayment,
  //         variables: {
  //           data,
  //         },
  //       });
  //       if (result.data) {
  //         const {
  //           registerPayment: { data },
  //         } = result.data;
  //         const redirectUrl = data?.links?.filter(
  //           (link) => link.rel === "approval_url"
  //         );

  //         window.location.replace(
  //           redirectUrl.length > 0 ? redirectUrl[0].href : ""
  //         );
  //       }
  //       setLoading(false);
  //     }
  //   } catch (ex) {
  //     setMessageData({
  //       ...message,
  //       desc: ex?.message,
  //       title: globalVariables.error,
  //     });
  //     modalRef.current.openModal();
  //   }
  // };

  const onPayForPending = async () => {
    try {
      setLoading(true);
      const result = await client.mutate({
        mutation: MakePendingDogPayments,
        variables: {
          amount: TotalPayment,
        },
      });
      if (result.data) {
        const {
          makePendingDogPayment: { data },
        } = result.data;

        const redirectUrl = data?.links?.filter(
          (link) => link.rel === "approval_url"
        );

        window.location.replace(
          redirectUrl.length > 0 ? redirectUrl[0].href : ""
        );
      }
      setLoading(false);
    } catch (ex) {
      setMessageData({
        ...message,
        desc: ex?.message,
        title: globalVariables.error,
      });
      modalRef.current.openModal();
    }
  };

  // Pay Later button ALWAYS just navigates to dashboard
  const ExtraProps = {
    hyperlinkLabel: globalVariables.payLater,
    hyperlinkLoading: false,
    onTapHyperlink: onPayLater,
  };

  return (
    <div className="App min-h-screen login-container-gradient overflow-auto">
      <Header
        rightComponent={
          <OutlineButton
            icon={logout}
            label={globalVariables.logout}
            prefix={false}
            width="w-[123px]"
            onClick={onLogout}
          />
        }
      />
      <div className="flex justify-center mt-8 flex-col items-center">
        <span className="text-2xl md:text-3xl font-semibold text-gray-900 mb-6">
          {globalVariables.makePayment}
        </span>
        {!isCustom && (
          <>
            <StepsHeader
              step={3}
              labels={[
                globalVariables.registerMember,
                globalVariables.registerDog,
                globalVariables.makePayment,
              ]}
            />
            <div className="mt-10" />
          </>
        )}
        <div className="mt-6" />
        <div className="w-[360px] max-[400px]:w-[90%] p-4 rounded-lg bg-white border border-gray-300 flex flex-col">
          <span className="text-xl font-semibold text-gray-900 self-center flex">
            {globalVariables.paymentSummary}
          </span>
          <div className="my-4 border-[0.5px] border-gray-300" />
          <span className="text-xs font-medium text-gray-700">
            {globalVariables.registrationFees}
          </span>
          {dogsData.map((e, index) => (
            <div className="flex flex-row justify-between mt-2" key={index}>
              <span className="text-base font-medium text-gray-700">
                {isNewFlow ? e?.call_name : e.callName}
              </span>
              <span className="text-base font-medium text-gray-700">
                ${DOG_REGISTRATION_FEE}
              </span>
            </div>
          ))}
          <div className="my-4 border-[0.5px] border-gray-300" />
          <div className="flex flex-row justify-between">
            <span className="text-base font-medium text-gray-700">
              {globalVariables.totalPrice}
            </span>
            <span className="text-lg font-bold text-gray-700">
              ${TotalPayment}
            </span>
          </div>
        </div>
      </div>
      <BottomButtons
        outlineLabel={globalVariables.back}
        fullLabel={`${globalVariables.pay} $${TotalPayment}`}
        onTapYes={() => {
          onPayForPending();
        }}
        disabled={loading}
        onTapNo={onGoBack}
        position="fixed"
        isPaypalButton
        {...ExtraProps}
      />
      <PopUpMessages
        title={message.title}
        desc={message?.desc}
        type={message.type}
        ref={modalRef}
      />
    </div>
  );
};
